export const MATERIAL_CATEGORY_LABELS = {
  asset: "资产",
  accessory: "低值易耗",
  consumable: "耗材",
  software: "软件",
} as const;

export const ASSET_STATUS_LABELS = {
  pending_acceptance: "待验收",
  in_stock: "在库可用",
  assigned: "已领用",
  borrowed: "借用中",
  return_pending: "归还待检",
  repairing: "维修中",
  pending_disposal: "待处置",
  disposed: "已处置",
  lost: "遗失/盘亏",
} as const;

export const LABEL_TASK_STATUS_LABELS = {
  pending: "待打印",
  printing: "打印中",
  printed: "已打印",
  failed: "打印失败",
  cancelled: "已取消",
} as const;

export const ACCESSORY_STATUS_LABELS = {
  in_stock: "入库",
  in_use: "使用中",
  returned: "返库",
  scrapped: "报废",
} as const;

export const LICENSE_MODE_LABELS = {
  subscription: "订阅制",
  term: "买断制（限期）",
  perpetual: "买断制（永久）",
} as const;

export const LICENSE_STATUS_LABELS = {
  pending: "待登记",
  active: "可用",
  expiring: "即将到期",
  expired: "已到期",
  terminated: "已终止",
  renewed: "已续期",
} as const;

export const SEAT_STATUS_LABELS = {
  available: "可用",
  pending: "待确认占用",
  allocated: "已分配",
  reclaimed: "已回收",
  revoked: "已吊销",
} as const;

export const CONFIRMATION_STATUS_LABELS = {
  pending: "待确认",
  confirmed: "已确认",
  rejected: "已拒绝",
  expired: "已过期",
  revoked: "已撤回",
} as const;

export function termLabel(
  map: Record<string, string>,
  key: string | null | undefined,
  fallback = "未关联",
): string {
  if (!key) return fallback;
  return map[key] ?? fallback;
}

export const REQUEST_TYPE_LABELS = {
  asset_claim: "资产申领",
  asset_borrow: "资产借用",
  accessory_apply: "低值易耗申领",
  consumable_issue: "耗材领用",
  software_seat: "软件席位",
} as const;

export const REQUEST_STATUS_LABELS = {
  pending_approval: "待审批",
  approved: "已批准",
  pending_fulfillment: "待办理",
  pending_confirmation: "待接收确认",
  completed: "已完成",
  rejected: "已拒绝",
  cancelled: "已取消",
  confirmation_expired: "确认超时",
} as const;

export const APPROVAL_ROLE_LABELS = {
  cost_center_owner: "成本中心负责人",
  direct_manager: "直属上级（人员关系）",
  finance_asset_admin: "财务固定资产管理员",
  finance_head: "财务部负责人",
  ceo: "CEO",
} as const;

export const HANDOVER_STATUS_LABELS = {
  pending: "待确认",
  confirmed: "已确认",
  rejected: "已拒绝",
  expired: "已超时",
} as const;
